import React from "react";

import { dataAttribute, DataAttributes, FontSizes, Link } from "@bps/fluent-ui";
import { Labels } from "@modules/practice/screens/shared-components/types/labels.enums.types.ts";

interface RemoveContactMethodLinkProps {
  index: number;
  onRemove: () => void;
}

export const RemoveContactMethodLink: React.FC<
  RemoveContactMethodLinkProps
> = ({ index, onRemove }) => {
  return (
    <Link
      id={`remove-comm-pref-${index}`}
      {...dataAttribute(
        DataAttributes.Element,
        "form-item-link-mobile-phone-remove"
      )}
      onClick={onRemove}
      styles={{
        root: {
          textAlign: "right",
          fontSize: FontSizes.small,
          padding: "5px 0"
        }
      }}
    >
      {Labels.remove}
    </Link>
  );
};
